import React from 'react'

import { Card, CardContent, CardMedia, Typography } from '@mui/material'
import { EVENTS } from '../../constants'

const cutString = (word, limit) => {
	return (word.length > limit && `${word.slice(0, limit)}...`) || word
}

const EventCard = ({ title, hour, subtitle, body, image, color, bg, btBg, eventType }) => {
	return (
		<Card
			sx={{
				maxWidth: 276,
				minWidth: 276,
				bgcolor: bg,
				borderRadius: '8px',
				color: (bg && 'white') || 'black',
				display: 'table',
			}}
		>
			{image && (
				<CardMedia
					component="div"
					alt={title}
					dangerouslySetInnerHTML={{ __html: image }}
					sx={(theme) => ({
						overflow: 'hidden',
						height: '164px',

						'& img': {
							width: '100%',
							height: 'initial',
						},
					})}
				/>
			)}

			<CardContent sx={{ textAlign: 'left' }}>
				<Typography
					variant="h6"
					sx={{ fontSize: 16, fontWeight: 600, color, textTransform: 'capitalize' }}
				>
					{title}
				</Typography>
				<Typography component="div" sx={{ fontSize: 14, fontWeight: 400, color }}>
					{hour}
				</Typography>
				<Typography
					component="p"
					sx={{
						bgcolor: btBg || (eventType && EVENTS.TYPES[eventType]),
						display: 'table',
						m: '1rem 0',
						p: '.2rem .6rem',
						fontWeight: 700,
						fontSize: 16,
					}}
				>
					{subtitle}
				</Typography>
				<Typography
					component="div"
					sx={{ fontSize: 14, fontWeight: 400, lineHeight: '1.2rem', color, minHeight: 56.7 }}
				>
					{cutString(body, 90)}
				</Typography>
			</CardContent>
		</Card>
	)
}

EventCard.defaultProps = {
	bg: 'text.white',
	eventType: '4',
}

export default EventCard
